class PaymentMethodPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'payment_method.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'payment_method._m';

    // Access detached payment methods
    static ACCESS_DETACHED = 'payment_method.access.detached';

    // Initiate sync
    static SYNC = 'payment_method.sync';
}

export default PaymentMethodPermission;
